import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import './scss/index.scss';
import MainPage from './component/main-page';
import StaticPage from '../component/static-page';
import ListPage from './component/list-page';
import URI from 'urijs';
import moIndex from '../store';
import moUser from '@/store/user';

interface IProps {}
interface IState {}

const Catalog = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const uri = new URI(window.location.href);
  const res: any = uri.query(true);
  const result = res?.data ? decodeURIComponent(res?.data) : '{}';
  const path = JSON.parse(result);
  const {
    salaryPage, leavePage, freshPage, diffPage,
    cityPage, recuitPage, companyPage, hotRolePage,
    budgetPage, holidayPage, conceptPage, aboutPage,
    hotjobPage,
  } = moIndex;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section>
      {/* 顶部静态资源 */}
      <section className="pdf-page-static-top">
        <MainPage />
      </section>
      <StaticPage
        url="https://file.smartsalary.cn/index-pdf/022.png"
        head={true}
        showuuid={false}
        onetitle="人力资源核心指标"
        twotitle={moIndex.industry.name}
      />
      <section className="pdf-page-static static-bg" style={{ marginTop: path?.type === 'export' ? 0 : '20px' }}>
        <p className='uuid'>{moUser.useruuid}</p>
        <ListPage show={true} />
        <section className="list-page-item">
          <section className="item-warps">
            <section className="one-title">
              <p className="top">
                <b>样本分布</b>
                <b>01</b>
              </p>
              <p className="bot">
                <b></b>
                <em></em>
                <i></i>
              </p>
            </section>
          </section>
          <section className="item-warps">
            <section className="one-title">
              <p className="top">
                <b>人力指标</b>
                <b></b>
              </p>
              <p className="bot">
                <b></b>
                <em></em>
                <i></i>
              </p>
            </section>
          </section>
          {salaryPage && (
            <section className="item-warps">
              <section className="two-title">
                <b>涨薪率</b>
                <b>{salaryPage}</b>
              </section>
            </section>
          )}
          {leavePage && (
            <section className="item-warps">
              <section className="two-title">
                <b>离职率</b>
                <b>{leavePage}</b>
              </section>
            </section>
          )}
          {freshPage && (
            <section className="item-warps">
              <section className="two-title">
                <b>应届生起薪</b>
                <b>{freshPage}</b>
              </section>
            </section>
          )}
          {diffPage && (
            <section className="item-warps">
              <section className="two-title">
                <b>城市薪酬差异系数</b>
                <b>{diffPage}</b>
              </section>
            </section>
          )}
          <section className="item-warps">
            <section className="one-title">
              <p className="top">
                <b>人力需求</b>
                <b></b>
              </p>
              <p className="bot">
                <b></b>
                <em></em>
                <i></i>
              </p>
            </section>
          </section>
          {recuitPage && (
            <section className="item-warps">
              <section className="two-title">
                <b>招聘趋势</b>
                <b>{recuitPage}</b>
              </section>
            </section>
          )}
          {cityPage && (
            <section className="item-warps">
              <section className="two-title">
                <b>城市招聘趋势</b>
                <b>{cityPage}</b>
              </section>
            </section>
          )}
        </section>
      </section>
      <section className="pdf-page-static static-bg" style={{ marginTop: path?.type === 'export' ? 0 : '20px' }}>
        <ListPage show={false} />
        <section className="list-page-item">
          {companyPage && (
            <section className="item-warps">
              <section className="two-title">
                <b>招聘动态</b>
                <b>{companyPage}</b>
              </section>
            </section>
          )}
          {hotRolePage && (
            <section className="item-warps">
              <section className="two-title">
                <b>热门职能</b>
                <b>{hotRolePage}</b>
              </section>
            </section>
          )}
          <section className="item-warps">
            <section className="one-title">
              <p className="top">
                <b>福利洞察</b>
                <b></b>
              </p>
              <p className="bot">
                <b></b>
                <em></em>
                <i></i>
              </p>
            </section>
          </section>
          {budgetPage && (
            <section className="item-warps">
              <section className="two-title">
                <b>企业预算</b>
                <b>{budgetPage}</b>
              </section>
            </section>
          )}
          {holidayPage && (
            <section className="item-warps">
              <section className="two-title">
                <b>员工福利</b>
                <b>{holidayPage}</b>
              </section>
            </section>
          )}
          <section className="item-warps">
            <section className="one-title">
              <p className="top">
                <b>热门岗位薪酬</b>
                <b>{hotjobPage}</b>
              </p>
              <p className="bot">
                <b></b>
                <em></em>
                <i></i>
              </p>
            </section>
          </section>
          <section className="item-warps">
            <section className="one-title">
              <p className="top">
                <b>概念与定义</b>
                <b>{conceptPage}</b>
              </p>
              <p className="bot">
                <b></b>
                <em></em>
                <i></i>
              </p>
            </section>
          </section>
          <section className="item-warps">
            <section className="one-title">
              <p className="top">
                <b>关于薪智</b>
                <b>{aboutPage}</b>
              </p>
              <p className="bot">
                <b></b>
                <em></em>
                <i></i>
              </p>
            </section>
          </section>
        </section>
      </section>
    </section>
  );
};

export default observer(Catalog);
